export default "__VITE_ASSET__2MVFhUZ7__"